<template>
  <DModal :isBgOverlay="true" :showClose="false">
    <div class="insert brutto text-dark brutto-container" slot="insertComponent">
      <div class="brutto-container__header">
        <h2>Indsæt ressourceforbrug på flere</h2>
        <div class="icon__bg-circle doc-modal__close" @click="close">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="brutto-container__body">
        <div class="brutto-container__body__left">
          <ul class="brutto__items">
            <li v-for="(item, idx) in items" :key="item.id" class="brutto__items__item__container">
              <div class="brutto__items__item">
                <span class="norm-title">{{ item.title }}</span>
                <div>
                  <div class="d-input-group__input">
                    <span class="label">Normalklasse</span>
                    <input type="number" v-model="item.nHours" @focus="$event.target.select()">
                  </div>
                  <div class="d-input-group__input">
                    <span class="label">Special klasse</span>
                    <input type="number" v-model="item.sHours" @focus="$event.target.select()">
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="brutto-container__footer">
        <button @click="$emit('close')">Annullér</button>
        <button class="bttn bttn-primary"
                @click="save"
                :class="[{'bttn--loading': isSaving}]">
          Gem
        </button>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal'
import docendo from '../../docendo'

export default {
  components: {DModal},
  props: {
    selectedUsers: {
      type: Array,
      default: () => []
    },
    schoolId: {
      default: null
    }
  },
  data () {
    return {
      isSaving: false,
      numberOfUsersSaved: 0,
      items: [
        {id: 'B', title: 'Antal arbejdstimer i alt', nHours: 1924, sHours: null},
        {id: 'A1', title: 'Fagopdelt undervisning', nHours: null, sHours: null},
        {id: 'A22', title: 'Understøttende undervisning', nHours: null, sHours: null},
        {id: 'A33', title: 'Øvrig tid med eleverne', nHours: null, sHours: null}
      ]
    }
  },
  computed: {
    itemsToSave () {
      let changes = {}
      this.items.forEach(item => {
        if (item.id === 'B') {
          changes['stil_hours_40_B'] = item.nHours
          changes['stil_hours_50_B'] = item.sHours
        }
        if (item.id === 'A1') {
          changes['stil_hours_40_A1'] = item.nHours
          changes['stil_hours_50_A1'] = item.sHours
        }
        if (item.id === 'A22') {
          changes['stil_hours_40_A22'] = item.nHours
          changes['stil_hours_50_A22'] = item.sHours
        }
        if (item.id === 'A33') {
          changes['stil_hours_40_A33'] = item.nHours
          changes['stil_hours_50_A33'] = item.sHours
        }
      })
      return changes
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      this.updateUsers()
      this.$emit('save', this.items)
    },
    updateUsers () {
      this.isSaving = true
      this.selectedUsers.forEach(user => {
        this.updateUser(user)
      })
    },
    updateUser (user) {
      let customData = user.custom_data
      let changes = {}
      for (const change in this.itemsToSave) {
        const val = this.itemsToSave[change]
        if (!customData['schools']) {
          customData.schools = {[this.schoolId]: {[change]: val}}
        }
        if (customData['schools'] && !customData['schools'][this.schoolId]) {
          customData['schools'][this.schoolId] = {[change]: val}
        }
        if (customData['schools'] && customData['schools'][this.schoolId]) {
          if (!val || val.length < 1) {
            delete customData['schools'][this.schoolId][[change]]
          } else {
            customData['schools'][this.schoolId][[change]] = val
          }
        }
      }
      changes['custom_data'] = customData
      docendo.updateUsers(this.schoolId, user.id, changes, data => {
        this.$store.commit('updateSchoolUser', data)
        this.numberOfUsersSaved++
        if (this.numberOfUsersSaved === this.selectedUsers.length) {
          this.close()
        }
      }, failure => {
        console.log('failure')
      })
    }
  }
}
</script>

<style>
.insert .d-input-group__input {
  margin-bottom: 0.5rem;
}

.insert .d-input-group__input span {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningRessourceInsertModal.vue?19f250f2